import styled from 'styled-components';
import toRem from 'utils/toRem';
import { WarningTriangle } from 'assets/icons';
import { error } from 'constants/variables';

const ErrorBox = ({ text }) => (
  <BorderBox>
    <WarningTriangle width={18} height={16} />
    <p className="fs-14 mb-0">{text}</p>
  </BorderBox>
);

const BorderBox = styled.div`
  color: ${error};
  border: 1px solid;
  padding: ${toRem(10)} ${toRem(12)};
  display: grid;
  grid-template-columns: 18px 1fr;
  gap: ${toRem(8)};
  margin-top: ${toRem(8)};
`;

export default ErrorBox;
